import { render, staticRenderFns } from "./ProdutosAtivos.vue?vue&type=template&id=06d8ca7a&"
import script from "./ProdutosAtivos.vue?vue&type=script&lang=js&"
export * from "./ProdutosAtivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
